import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/App.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/splash-screen.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/app/public/assets/fonts/material-design-icons/MaterialIconsOutlined.css");
;
import(/* webpackMode: "eager" */ "/app/public/assets/fonts/Geist/geist.css");
;
import(/* webpackMode: "eager" */ "/app/public/assets/fonts/meteocons/style.css");
;
import(/* webpackMode: "eager" */ "/app/public/assets/styles/prism.css");
